export default "__VITE_ASSET__CPaIDmGB__"